import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReactiveFormService } from '../../services/reactive-form.service';

@Component({
    selector: 'kt-input-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, OnChanges {
    @Input() fieldObj: any;
    @Input() options: any;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();

    dropdownOptions: any = '';
    isHideExpression = false;
    subscriptions: Subscription[] = [];

    constructor(public formService: ReactiveFormService) { }

    ngOnInit() {
        this.setValidations();
        this.hideExpression();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue) {
            this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
        }

        if (changes && changes.options && changes.options.currentValue) {
            this.options = changes.options.currentValue;
        }
    }

    notifyChange(data) {
        this.valueChange.emit({ name: this.fieldObj.key, value: data });
    }

    hideExpression() {
        if (this.fieldObj && this.fieldObj.hideExpression && this.fieldObj.hideExpression.fieldName) {
            this.clearValidations();
            this.subscriptions.push(this.form.controls[this.fieldObj.hideExpression.fieldName].valueChanges.subscribe(val => {
                if (this.fieldObj.hideExpression.fieldValue === this.formService.matchValueExpression(val)) {
                    this.isHideExpression = false;
                    this.setValidations();
                } else {
                    this.clearValidations();
                }
            }));
        }
    }

    setValidations() {
        this.form.controls[this.fieldObj.key].validator =
            Validators.compose([this.fieldObj.required ? Validators.required : null]);
    }

    clearValidations() {
        this.isHideExpression = true;
        this.form.controls[this.fieldObj.key].clearValidators();
        this.form.controls[this.fieldObj.key].updateValueAndValidity();
    }

    // tslint:disable-next-line: use-life-cycle-interface
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }


}
